import { FC, useMemo } from 'react';

import { marked } from 'marked';

export const ChatBotMessageComment: FC<{ text: string }> = ({ text }) => {
  const html = useMemo(() => marked.parse(text, { async: false }), [text]);

  return (
    <div
      className="text-md text-gray-900 prose prose-li:marker:text-gray-900 prose-p:my-0"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
